import React, { lazy, Suspense } from 'react'
import { createRoot, ErrorInfo } from 'react-dom/client'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import utc from 'dayjs/plugin/utc'

import { globalError } from './globalError'

dayjs.extend(customParseFormat)
dayjs.extend(utc)

const App = lazy(() => import('./app/app'))
const Css = lazy(() => import('./app/importCss'))

window.addEventListener('error', globalError)

const rootElement = document.getElementById('root') as HTMLElement
if (!rootElement) throw new Error('Failed to find the root element')
const root = createRoot(rootElement, {
  onRecoverableError: (error: unknown, errorInfo: ErrorInfo) => {
    globalError({ error: { error: error, errorInfo: errorInfo } })
  }
})
root.render(
  <React.StrictMode>
    <Suspense>
      <Css />
      <App />
    </Suspense>
  </React.StrictMode>
)
